// app/javascript/controllers/plyr_controller.js
import { Controller } from "@hotwired/stimulus"
import Plyr from "plyr"

export default class extends Controller {
  static targets = ["player"]
  static values = {
    options: Object,
    source: Object
  }

  connect() {
    this.initializePlayer()
  }

  disconnect() {
    if (this.player) {
      this.player.destroy()
    }
  }

  initializePlayer() {
    const defaultOptions = {
      controls: [
        'play-large',
        'play',
        'progress',
        'current-time',
        'mute',
        'volume',
        'settings',
        'fullscreen'
      ],
      settings: ['quality', 'speed'],
      quality: {
        default: 720,
        options: [1080, 720, 480, 360]
      },
      speed: {
        selected: 1,
        options: [0.5, 0.75, 1, 1.25, 1.5, 1.75, 2]
      },
      hideControls: true,
      clickToPlay: true,
      keyboard: { focused: true, global: false },
      tooltips: { controls: true, seek: true },
      displayDuration: true,
      invertTime: false,
      toggleInvert: true
    }

    const options = this.hasOptionsValue ?
      { ...defaultOptions, ...this.optionsValue } :
      defaultOptions

    this.player = new Plyr(this.playerTarget, options)

    if (this.hasSourceValue) {
      this.player.source = this.sourceValue
    }
  }

  updateSource(event) {
    const newSource = event.detail.source
    if (this.player && newSource) {
      this.player.source = newSource
    }
  }

  play() {
    if (this.player) {
      this.player.play()
    }
  }

  pause() {
    if (this.player) {
      this.player.pause()
    }
  }

  toggle() {
    if (this.player) {
      this.player.togglePlay()
    }
  }
}
